export default __webpack_public_path__ + "static/media/profile.208623a1.png";